import type { IconType } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { ACADEMY_MENU_ROUTES } from './academyMenuRoutes.const'

export type AcademyNavItemId = 'home' | 'quickStart' | 'documentation' | 'glossary' | 'codeSandbox'

export type AcademyNavItem = {
  id: AcademyNavItemId
  label: string
  path: string
  icon: IconType
}

export type AcademyNavSection = {
  label?: string
  items: AcademyNavItem[]
}

export const ACADEMY_NAV_SECTIONS: AcademyNavSection[] = [
  {
    items: [{ id: 'home', label: 'Home', path: ACADEMY_MENU_ROUTES.home, icon: Icon.HomeFilled }],
  },
  {
    label: 'Learn',
    items: [
      { id: 'quickStart', label: 'Quick start', path: ACADEMY_MENU_ROUTES.quickStart, icon: Icon.FastForwardRegular },
      {
        id: 'documentation',
        label: 'Documentation',
        path: ACADEMY_MENU_ROUTES.documentation,
        icon: Icon.DocumentRegular,
      },
      { id: 'glossary', label: 'Glossary', path: ACADEMY_MENU_ROUTES.glossary, icon: Icon.BookRegular },
    ],
  },
  {
    label: 'Practice',
    items: [{ id: 'codeSandbox', label: 'Code Sandbox', path: ACADEMY_MENU_ROUTES.codeSandbox, icon: Icon.DSTerminal }],
  },
]
